import React, { memo } from "react";
import { Avatar, Space, Popover, message, Divider, Typography } from "antd";
import { UserOutlined, ReloadOutlined } from "@ant-design/icons";
import QuickAdd from "../components/Drawer/QuickAdd";
import QuickMessage from "../components/Drawer/QuickMessage";
import { PermissionService } from "../Services/Permission/PermissionService";

const { Text } = Typography;

const HeaderBar = () => {
  const ome_user = JSON.parse(localStorage.getItem("ome_user"));

  const handleReloadPermission = async () => {
    try {
      if (!ome_user?.uid) {
        message.error("User ID not found!");
        return;
      }

      const uid = ome_user.uid;
      const response = await PermissionService.getPermissionDetailsById(uid);
      console.log("Permissions response:", response);

      localStorage.setItem(
        "ome_permission",
        JSON.stringify(response.data.permissions)
      );

      message.success("Permissions reloaded successfully!");
    } catch (error) {
      console.error(error);
      message.error("Failed to reload permissions.");
    }
  };

const popoverContent = (
  <div style={{ minWidth: 250, padding: "10px" }}>

    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        cursor: "pointer",
        padding: "5px 10px",
        borderRadius: 4,
        transition: "background 0.2s",
      }}
      onClick={handleReloadPermission}
      onMouseEnter={e => (e.currentTarget.style.background = "#f0f0f0")}
      onMouseLeave={e => (e.currentTarget.style.background = "transparent")}
    >
      <ReloadOutlined />
      <span>Reload Permission</span>
    </div>

    <Divider style={{ margin: "10px 0" }} />

 
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "120px 1fr",
        rowGap: 6,
        columnGap: 8,
      }}
    >
       <Text strong>UID:</Text>
      <Text>{ome_user?.uid}</Text>

      <Text strong>Name:</Text>
      <Text>{ome_user?.name}</Text>

      <Text strong>Phone:</Text>
      <Text>{ome_user?.phone}</Text>

      <Text strong>Role:</Text>
      <Text>{ome_user?.role}</Text>

      <Text strong>Status:</Text>
      <Text>{ome_user?.status}</Text>

      <Text strong>UID:</Text>
      <Text>{ome_user?.uid}</Text>

      <Text strong>Email:</Text>
      <Text>{ome_user?.email}</Text>

      <Text strong>Joined On:</Text>
      <Text>{new Date(ome_user?.added_on).toLocaleDateString()}</Text>
    </div>
  </div>
);


  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        padding: "10px 30px",
        width: "100%",
        height: "64px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      }}
    >
      <Space size="large">
        <QuickAdd />
        <QuickMessage />

        <Popover content={popoverContent} trigger="hover" placement="bottom">
          <Avatar
            style={{ backgroundColor: "#87d068", cursor: "pointer" }}
            icon={<UserOutlined />}
          />
        </Popover>
      </Space>
    </div>
  );
};

export default memo(HeaderBar);
